// Provides a way to ensure multiple function calls are only called once
// Uniqueness currently only based off of functions, not args (that could get crazy)
export const uniqueCallbackQueue = () => {
    let queueArr = []
    let timeoutId

    return function(fx, args) {
        clearTimeout(timeoutId)
        if (!queueArr.find((item) => item.fx === fx)) {
            queueArr.push({ fx, args })
        }
        timeoutId = setTimeout(() => {
            queueArr.forEach((item) => item.fx(...item.args))
            queueArr = []
        }, 1000)
    }
}
